import { PRODUCT_DESCRIPTION_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/ProductDescriptionAccordion/ProductDescriptionAccordionUI";
const productDescriptionAccordionSelector = "#accordion-description";

export const handleCTAClickToScroll =
  (selector: string, options: ScrollIntoViewOptions = {}) =>
  () => {
    const scrollIntoView = () =>
      document
        .querySelector(selector)
        ?.scrollIntoView({ ...options, behavior: "smooth" });

    setTimeout(scrollIntoView, 0);
  };

export const handleAccordionDescriptionCTAClick = () => {
  document.body.dispatchEvent(
    new CustomEvent(
      `jlds:accordion:${PRODUCT_DESCRIPTION_ACCORDION_INSTANCE_NAME}`,
      {
        detail: { action: "open" },
      },
    ),
  );

  handleCTAClickToScroll(productDescriptionAccordionSelector, {
    block: "start",
  })();
};

export const getPriceValueOrRange = (
  priceData: { max: string; min: string } | string | undefined,
) => {
  if (typeof priceData === "object") {
    return priceData.max === priceData.min
      ? priceData.min
      : {
          from: priceData.min,
          to: priceData.max,
        };
  }
  return priceData || "";
};
